import styled from 'styled-components'
import { activeRos } from '../../components/Ads/Interstitial/Maavaron'

export const InterstitialWrap = styled.div`
  position: absolute;
  height: 0;
  z-index: 2001;

  #${activeRos} {
    height: 0;
    overflow: visible;
  }
`
